export const announcementBannerStyles = [
    { value: 'primary', text: 'Primary' },
    { value: 'neutral', text: 'Neutral' },
    { value: 'warning', text: 'Warning' },
    { value: 'error', text: 'Error' },
    { value: 'info', text: 'Info' },
];
//# sourceMappingURL=types.js.map